import { AxiosResponse } from "axios";
import { API } from "../index";
import {
  GroupReservationAgencyContext,
  GroupReservationPublicConfig,
  GroupReservationRequest,
  GroupReservationRequestPayload,
} from "@/api/types/group-reservation";

export const groupReservationService = {
  getPublicConfig: async (): Promise<AxiosResponse<GroupReservationPublicConfig>> => {
    return await API.get("/api/v2/group-reservation/config/");
  },

  getAgencyContext: async (token: string): Promise<AxiosResponse<GroupReservationAgencyContext>> => {
    return await API.get(`/api/v2/group-reservation/agency-links/${token}/`);
  },

  createRequest: async (
    payload: GroupReservationRequestPayload
  ): Promise<AxiosResponse<GroupReservationRequest>> => {
    return await API.post("/api/v2/group-reservation-requests/", payload);
  },
};
